// Öğretmen puanı (`zorluk_puan`) -> zorluk seviyesi: AD + RENK TEK KAYNAĞI.
//
// Sınıflandırma (öğretmen kararı, 2026-08-31):
//
//   1      hatalı   — revizelik. ZORLUK DEĞİL, tek kalite sinyali.
//   2-4    kolay
//   5-6    orta
//   7-9    zor
//   10     çok zor
//
// NEDEN TEK DOSYA: puan rozeti panelde ÜÇ ayrı yerde basılıyordu (App.js liste
// rozeti + grup çipleri, SoruKarti.js detay rozeti) ve puan verme butonları
// DÖRDÜNCÜ bir eşik seti kullanıyordu (<=3 kırmızı / <=6 sarı / gerisi yeşil).
// Hiçbiri diğeriyle uyuşmuyordu ve hiçbiri 1'i ayırmıyordu — 1 puanlı "hatalı"
// soru, 3 puanlı sağlam kolay soruyla aynı kırmızıydı. Yeni bir basım yeri
// eklenirse eşiği kopyalamak yerine buradan okur.
//
// RENK MANTIĞI (2026-09-23, kullanıcı kararı): puan rozeti ders etiketiyle aynı
// renge düşmesin diye zorluk TEK TON skalasıdır — gri koyulaştıkça zorlaşır
// (slate-500 kolay -> slate-900 çok zor). Kırmızı YALNIZ hatalı (1) içindir.
// Ders paleti (lib/dersler.js) gri/slate ve kırmızı KULLANMAZ; yeni ders rengi
// eklerken bu iki aileden kaçın.
//
// ⚠️ KAPSAM DIŞI: Basım sekmesindeki kova çipleri (components/Basim.js) bu
// dosyayı KULLANMAZ. Oradaki renk `backend/src/lib/denemeFormat.js` ZORLUK_KOVA
// sınırlarını (kolay 2-4 / orta 5-7 / zor 8-10) gösterir — yani sorunun hangi
// kovadan basılacağını. İki sınır seti 7 ve 10'da ayrışır; basım motoru bu
// sınıflandırmaya taşınırsa Basim.js de buraya bağlanır.

/** Bantlar — sıralı, kapsayıcı (min/max dahil). */
export const ZORLUK_SEVIYELERI = [
  // `filtreAd`: panel puan FİLTRESİNDE gösterilecek ad, `ad`dan farklıysa. 1 bandında
  // ikisi bilinçli ayrı: rozet sorunun DURUMUNU söyler ("hatalı"), filtre ise yapılacak
  // İŞİ ("revize") — öğretmen ikisini de bu anlamda kullandı (2026-08-31).
  { ad: 'hatalı',  filtreAd: 'revize', min: 1, max: 1, renk: '#DC2626', aktifSinif: 'bg-red-600 text-white border-red-700' },
  { ad: 'kolay',   min: 2,  max: 4,  renk: '#64748B', aktifSinif: 'bg-slate-500 text-white border-slate-600' },
  { ad: 'orta',    min: 5,  max: 6,  renk: '#475569', aktifSinif: 'bg-slate-600 text-white border-slate-700' },
  { ad: 'zor',     min: 7,  max: 9,  renk: '#1E293B', aktifSinif: 'bg-slate-800 text-white border-slate-900' },
  { ad: 'çok zor', min: 10, max: 10, renk: '#0F172A', aktifSinif: 'bg-slate-900 text-white border-black' },
];

/** Puansız/aralık dışı için açık gri (rozet zaten "Puan yok" der; "kolay" tonundan ayrı). */
export const ZORLUK_RENK_YOK = '#9CA3AF';

/** Puan -> bant nesnesi; puansız veya 1-10 dışıysa null. */
export function zorlukSeviye(puan) {
  const p = Number(puan);
  if (!Number.isFinite(p)) return null;
  return ZORLUK_SEVIYELERI.find(s => p >= s.min && p <= s.max) || null;
}

/** Puan -> rozet zemin rengi. */
export function puanRenk(puan) {
  const s = zorlukSeviye(puan);
  return s ? s.renk : ZORLUK_RENK_YOK;
}

/** Puan -> seviye adı ('hatalı' | 'kolay' | 'orta' | 'zor' | 'çok zor' | ''). */
export function puanSeviyeAdi(puan) {
  const s = zorlukSeviye(puan);
  return s ? s.ad : '';
}

/** Rozet/çip tooltip metni: "7/10 — zor". */
export function puanBaslik(puan) {
  const s = zorlukSeviye(puan);
  if (!s) return 'puan verilmedi';
  return s.ad === 'hatalı'
    ? '1/10 — hatalı soru (revize edilecek)'
    : `${puan}/10 — ${s.ad}`;
}

/**
 * Panel puan filtresi seçenekleri — bantlardan TÜRETİLİR, elle yazılmaz.
 * `value` doğrudan API'ye `?puan=` olarak gider; backend `puanWhere` bunu
 * `N` veya `N-M` deseni olarak ayrıştırır (sabit beyaz liste YOK — liste
 * tutulduğunda frontend'e eklenen yeni bant backend'de sessizce FİLTRESİZ
 * sonuç döndürüyordu).
 */
export const ZORLUK_FILTRE_SECENEKLERI = ZORLUK_SEVIYELERI.map((sv) => {
  const aralik = sv.min === sv.max ? `${sv.min}` : `${sv.min}-${sv.max}`;
  return { value: aralik, label: `${aralik} · ${sv.filtreAd || sv.ad}` };
});

// ── PUAN SEVİYESİ ÇOKLU SEÇİMİ (2026-10-26, kullanıcı isteği "her seviye checkbox ile seçilebilsin,
// genel olarak kullanılsın"). Değerler backend lib/puanSeviye ile aynı dil: 'yok' | 'N' | 'N-M';
// liste API'ye virgülle gider (`puan=yok,2-4,7-9`). Boş seçim = tümü.

/** Panel liste süzgeci ve müşteri paneli: 'Puan yok' + bantlar (1 · revize dahil). */
export const PUAN_SECENEKLERI = [{ value: 'yok', label: 'Puan yok' }, ...ZORLUK_FILTRE_SECENEKLERI];

/** Basım (Konu Testi / Genel Deneme, dengeli seçim, "Değiştir"): 1 puan ve puansız basılmaz. */
export const BASIM_PUAN_SECENEKLERI = ZORLUK_FILTRE_SECENEKLERI.filter((o) => o.value !== '1');

/** Basım "Soru ekle" araması: puansız + bantlar, 1 puan yok (1 puanlı soru basıma girmez). */
export const ARAMA_PUAN_SECENEKLERI = PUAN_SECENEKLERI.filter((o) => o.value !== '1');

/**
 * Müşteri paneli: puansız + 2…10 HER PUAN AYRI kutu (kullanıcı isteği 2026-10-26 "tüm puanlar checkbox ile
 * seçilebilmeli"). 1 puanlı soru müşteriye zaten gösterilmez. Backend `puan=N` parçasını zaten kabul eder.
 */
export const MUSTERI_PUAN_SECENEKLERI = [
  { value: 'yok', label: 'Puan yok' },
  ...[2, 3, 4, 5, 6, 7, 8, 9, 10].map((p) => ({ value: `${p}`, label: `${p} · ${puanSeviyeAdi(p)}` })),
];

/** 'a,b' dizgisi ya da dizi -> tekrarsız değer dizisi. */
export function puanSecimListesi(deger) {
  const ham = Array.isArray(deger) ? deger : String(deger || '').split(',');
  return [...new Set(ham.map((x) => String(x).trim()).filter(Boolean))];
}

/** Değer dizisi -> seçenek sırasıyla kanonik virgüllü dizgi ('' = tümü). */
export function puanSecimMetni(liste, secenekler = PUAN_SECENEKLERI) {
  const s = new Set(puanSecimListesi(liste));
  return secenekler.map((o) => o.value).filter((v) => s.has(v)).join(',');
}

/** Düğme metni: 'tümü' ya da seçili seviyelerin kısa adları ("kolay, zor"). */
export function puanSecimOzeti(deger, secenekler = PUAN_SECENEKLERI) {
  const s = new Set(puanSecimListesi(deger));
  const secili = secenekler.filter((o) => s.has(o.value));
  if (secili.length === 0 || secili.length === secenekler.length) return 'tümü';
  // Tek puanlı listede (müşteri) kısa ad belirsiz ("zor, zor") → puanın kendisi yazılır.
  const tekPuanli = secenekler.filter((o) => o.value !== 'yok').length > 5;
  return secili.map((o) => (o.value === 'yok' ? 'puansız' : tekPuanli ? o.value : o.label.split(' · ')[1] || o.label)).join(', ');
}

/**
 * Eski Basım taslağı (puanMin/puanMax, 2026-10-26 öncesi) -> aralıkla KESİŞEN basım seviyeleri.
 * Kutular yalnız tam bantları gösterdiği için kısmi bant tam bant olur (3-6 -> kolay + orta).
 * İkisi de boşsa [] (= tümü).
 */
export function puanAraligiSeviyeleri(min, max) {
  const bos = (v) => v === '' || v == null || !Number.isFinite(Number(v));
  if (bos(min) && bos(max)) return [];
  const alt = bos(min) ? 2 : Number(min);
  const ust = bos(max) ? 10 : Number(max);
  return BASIM_PUAN_SECENEKLERI.filter((o) => {
    const [a, b = a] = o.value.split('-').map(Number);
    return a <= ust && b >= alt;
  }).map((o) => o.value);
}
